export default "__VITE_ASSET__BE7KjHHU__"